module.exports = __webpack_public_path__ + "img/vip_pc_tab_02.6b3c6566.png";